import { render, staticRenderFns } from "./CreateLimit.vue?vue&type=template&id=48cc6594&scoped=true&"
import script from "./CreateLimit.vue?vue&type=script&lang=js&"
export * from "./CreateLimit.vue?vue&type=script&lang=js&"
import style0 from "./CreateLimit.vue?vue&type=style&index=0&id=48cc6594&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cc6594",
  null
  
)

export default component.exports